export const environment = {
  production: true,
  configPath: './assets/config/env_development.json'
};
